import React, {Component} from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';

import * as firebase from 'firebase';

class ChatRoomSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openEditRoomName: false,
      newRoomName: this.props.title,
      openPopover: false
    };
  }

  handleRoomNameOpen = () => {
    this.setState({
      openEditRoomName: true,
      newRoomName: this.props.title,
      openPopover: false
    });
  }

  handleRoomNameClose = () => {
    this.setState({
      openEditRoomName: false
    });
  }

  handleEditRoomNameChange = (event) => {
    event.preventDefault();
    this.setState({
      newRoomName: event.target.value,
    });
  }

  handleRoomNameSave = () => {
    if (this.state.newRoomName !== this.props.title) {
      const updates = {};
      updates[`rooms/${this.props.roomId}/metadata/title`] = this.state.newRoomName;
      firebase.database().ref().update(updates);
      this.setState({openEditRoomName: false});
    }
  }

  handlePopoverOpen = (event) => {
    event.preventDefault();
    this.setState({
      openPopover: true,
      anchorEl: event.currentTarget,
    });
  };

  handlePopoverClose = () => {
    this.setState({ openPopover: false});
  }

  render() {
    const editRoomNameActions = [
    <FlatButton
      label="Cancel"
      primary={true}
      onClick={this.handleRoomNameClose}
    />,
    <FlatButton
      label="Save"
      primary={true}
      keyboardFocused={true}
      onClick={this.handleRoomNameSave}
    />,
  ];

    return (
      <div>
        <IconButton
          iconClassName="material-icons"
          tooltip="Settings"
          iconStyle={{color:'#757575'}}
          onClick={this.handlePopoverOpen}
        >settings</IconButton>
        <Popover
          open={this.state.openPopover}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'left', vertical: 'top'}}
          onRequestClose={this.handlePopoverClose}
        >
          <Menu>
            <MenuItem
              primaryText="Rename"
              onClick={this.handleRoomNameOpen}/>
          </Menu>
        </Popover>
        <Dialog
          title="Edit room name"
          actions={editRoomNameActions}
          modal={false}
          open={this.state.openEditRoomName}
          onRequestClose={this.handleRoomNameClose}
        >
          <input
            className="field-input"
            type="text"
            ref="input"
            value={this.state.newRoomName}
            onChange={this.handleEditRoomNameChange}/>
        </Dialog>
      </div>
    );
  }
}

export default ChatRoomSettings;



// WEBPACK FOOTER //
// ./src/chat/ChatRoomSettings.js